import api from "../../utils/api";
import { get as getNotifications } from "../notifications";
import { mine as getPermissions } from "../permissions";

import {
  AUTH_ERROR,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOGOUT,
  USER_LOADED,
  PASSWORD_CHANGE
} from "../types";

export const permitted = (name) => async (dispatch) => {
  try {
    const res_permitted = await api.get(`/users/me/permitted/n/${name}`);
    return res_permitted?.status === 200;
  } catch (error) {
    return false;
  }
}

export const get = () => async (dispatch) => {
  try {
    const res = await api.get("/users/me");
    const res_permitted = await api.get("/users/me/permitted/n/CAN.LOGIN");
    if (res_permitted.status !== 200) throw new Error(res_permitted?.data?.msg);
    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
    dispatch(getNotifications());
    dispatch(getPermissions());
    return res.data;
    
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

export const persistTokenizedSession = (instance, token, url) => {
    localStorage.setItem("instance", instance);
    localStorage.setItem("token", token);
    if (url) localStorage.setItem("api", url);
};

export const tokenize = (instance, token, url) => async (dispatch) => {
  try {
    persistTokenizedSession(instance, token, url);

    const res = await api.get("settings/p/c/FrontEnd");
    
    localStorage.setItem("title", res.data["SITE_TITLE"]);
    localStorage.setItem("loginUrl", res.data["LOGINURL"]);
    localStorage.setItem("smallLogo", res.data["SMALL_LOGO"]);
    localStorage.setItem("features", res.data["FEATURES"]);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: { token, instance },
    });

    dispatch(get());

    return true;
  } catch (error) {
    console.log(error);
    dispatch({
      type: LOGIN_FAILED,
    });
  }
  return false;
}

export const changePassword = (userId, passwords) => async (dispatch) => {
  try {
    const res = await api.post(`/users/${userId}/password/change`, passwords);
    dispatch({
      type: PASSWORD_CHANGE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const reset = (email) => async (dispatch) => {
  try {
    const res = await api.post(`/auth/reset`, { email });
    return res.data;
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
}


export const logout = () => async (dispatch) => {
    dispatch({ type: LOGOUT });
};

